export var REQUEST_GET_CART = 'REQUEST_GET_CART';
export var REQUEST_ADD_CART = 'REQUEST_ADD_CART';
export var REQUEST_DELETE_CART = 'REQUEST_DELETE_CART';
export var REQUEST_CLEAR_CART = 'REQUEST_CLEAR_CART';
export var RECEIVE_CHANGE_CART = 'RECEIVE_CHANGE_CART';
export var FAILURE_CART = 'FAILURE_CART';